{
    "FullName": "Voor-en achternaam:",
    "FullNamePlaceholder": "[Volledige naam niet gespecificeerd]",
    "UsernameHint": "De gebruikersnaam hoeft geen e-mailadres te zijn, maar moet uniek identificeerbaar zijn en is hoofdlettergevoelig",
    "UsernameEditHint": "Bij het bewerken van een gebruikersnaam moet het wachtwoord opnieuw worden ingevoerd",
    "Email": "E-mail:",
    "EmailPlaceholder": "voorbeeld@domein.com",
    "EmailHint": "Waar de automatisch gegenereerde e-mailberichten naartoe worden gestuurd. (E-mails voor nieuwe gebruikers\/welkom, resetten van wachtwoorden en geplande rapporten)",
    "Defaultlanguage": "E-mailtaal:",
    "DefaultlanguageHint": "Help weergeven voor gebruikers die bulksgewijs uploaden.",
    "Passwordchange": "Wachtwoord wijzigen vereist:",
    "Welcomeemail": "Welkomst-e-mail verzenden:",
    "WelcomeemailHelp": "Deze optie is beschikbaar wanneer een geldig e-mailadres en wachtwoord is ingevoerd en de instelling Wachtwoord wijzigen vereist is ingeschakeld",
    "NameValidation": "Volledige naam mag niet langer zijn dan 100 tekens",
    "UsernameRequiredValidation": "Gebruikersnaam:",
    "EmailPatternValidation": "Gelieve een geldig e-mailadres in te geven",
    "PasswordLengthValidation": "Wachtwoord is te kort",
    "PasswordRequiredValidation": "Wachtwoord mag niet leeg zijn",
    "PasswordStrengthValidation": "Wachtwoord is niet sterk genoeg (let op hoofdletters en kleine letters en cijfers)",
    "UserDetailsLanguage_Username": "Gebruikersnaam:",
    "UserDetailsLanguage_Password": "Wachtwoord:",
    "UserDetailsLanguage_PasswordPlaceholder": "••••••••",
    "NAME": "UserDetailsLanguage",
    "UsernameIDOnTelSysHint": "De gebruikersnaam kan niet worden bewerkt voor dit abonnementstype. De gebruikersnaam moet overeenkomen met de gebruikersnaam op het telefonieplatform.",
    "EmailRequiredValidation": "E-mailadres mag niet leeg zijn",
    "UserDetailsLanguage_MFA_Label": "MFA inschakelen:",
    "UserDetailsLanguage_MFAHelp": "Het inschakelen van Multi-Factor Authenticatie (MFA) betekent dat de gebruiker een code van zijn authenticator-app moet invoeren wanneer hij inlogt.",
    "Timezone_Title": "Tijdzone:",
    "UserDetailsLanguage_CXIntegration": "CX-integratie:",
    "UsernameMustBeSetFromDeviceValidation": "Om de gebruikersnaam voor dit gebruikerstype te verkrijgen, moet u ervoor zorgen dat het apparaat is ingesteld op het tabblad Machtigingen"
}